// extracted by mini-css-extract-plugin
export default {"container":"ReorderableItem_container__bka9M","content":"ReorderableItem_content__9S0St"};